import { SwiperSlide } from 'swiper/react'
import { A11y, Navigation, Pagination } from 'swiper/modules'
import { WCONT_MD } from '@utils/settings'
import { GenericSectionThemeType, MenuItemType } from '@utils/types'
import { GenericCard } from '@components/molecules'
import { GenericSection, GenericSlider } from '@components/organisms'
import styles from './GenericCardSwiper.module.sass'

interface Props {
  id: string
  refId?: string
  item: MenuItemType
  theme?: GenericSectionThemeType
  className?: string
}

const GenericCardSwiper = (props: Props) => {
  const {
    id = undefined,
    refId = undefined,
    item = undefined,
    theme = 'neutral10',
    className = '',
  } = props

  return item?.children?.length ? (
    <GenericSection
      refId={refId}
      item={item}
      theme={theme}
      className={`${styles.root} ${className}`}
    >
      <GenericSlider
        id={id}
        navigationPos="pagination"
        conf={{
          modules: [A11y, Navigation, Pagination],
          slidesPerView: 'auto',
          spaceBetween: 10,
          navigation: true,
          pagination: { clickable: true },
          breakpoints: {
            576: {
              slidesPerView: 2.1,
            },
            768: {
              slidesPerView: 3.1,
            },
            992: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          },
        }}
        className={styles.slider}
      >
        {item.children.map((i) => (
          <SwiperSlide key={i.pk}>
            <GenericCard item={i} />
          </SwiperSlide>
        ))}
      </GenericSlider>
    </GenericSection>
  ) : (
    <></>
  )
}

export default GenericCardSwiper
